export default __webpack_public_path__ + "static/media/06-ideation-planning.ce7184d7.svg";